import React, {useEffect} from "react";
import {useSnackbarState} from "../../context/SnackBarContext";
import {SnackbarProvider, useSnackbar} from 'notistack';
import Grow from '@material-ui/core/Grow';
import './SnackbarStyleSheet.css'

const snackbarRef = React.createRef();

function SnackbarLayout(props) {

    return (<SnackbarProvider
            ref={snackbarRef}
            maxSnack={5}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            TransitionComponent={Grow}
            autoHideDuration={3000}
            action={(key) => (
                <button
                    onClick={() => snackbarRef.current.closeSnackbar(key)}
                    style={{
                        border: 'none',
                        background: 'transparent',
                        color: 'transparent',
                        fontSize: '20px',
                        paddingLeft: '1rem',
                        width: '100%'
                    }}
                >
                    ✖
                </button>
            )}
        >
            <SnackbarContainer/>
            {
                props.children
            }</SnackbarProvider>
    )
}

export default SnackbarLayout;


const SnackbarContainer = () => {

    const snackbarState = useSnackbarState()

    useEffect(() => {
        if (snackbarState.snackbarMessage) {
            handleClickVariant(snackbarState.snackbarType, snackbarState.snackbarMessage)
        }
    }, [snackbarState])

    const enqueueSnackbar = useSnackbar();

    function handleClickVariant(variant, message) {
        if (typeof enqueueSnackbar !== 'undefined') {
            const snackbar = enqueueSnackbar.enqueueSnackbar
            snackbar(message,
                {
                    variant: variant
                });
            const timer = setInterval(() => {

            }, 1000);
        }
    }

    return (<></>)
}